import { Component, OnInit } from '@angular/core';


import "survey-core/survey.i18n.js";
import "survey-creator-core/survey-creator-core.i18n.js";

import { surveyLocalization } from 'survey-core';
import {  Model } from "survey-core";

import { ComponentCollection } from "survey-core";
import { Serializer } from "survey-core";
import { MenuItem, MessageService } from 'primeng/api';
import { SurveyCreatorModel, localization } from "survey-creator-core";
import { setLicenseKey } from "survey-core";

import { ApiService } from 'src/app/_services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/_services/global.service';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  selector: 'app-survey-startup-model-edit',
  templateUrl: './survey-startup-model-edit.component.html',
  styleUrls: ['./survey-startup-model-edit.component.css'],
  providers: [ MessageService]
})
export class SurveyStartupModelEditComponent implements OnInit {
  surveyCreatorModel: SurveyCreatorModel;
  isLoading=true;
  surveyModel: Model;
  archived:boolean =false;
  creator:any;
  surveymodel={
    name:''
  };
  readonly:boolean=false;
  showDialogDuplicate:boolean=false;
  action='';  
  duplicatename='';
  id:number;
  breadcrumbs: MenuItem[];
  errors: {
    DescrizioneError: boolean,

  };
  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
    private translate: TranslateService,
    private globalService: GlobalService,
    private route: ActivatedRoute,
    private router: Router,
  ) { 
    setLicenseKey("Y2UyZmM4MzktN2Y3ZS00MGY3LWEwOGYtMzM1YjE3MTkwMzkwOzE9MjAyNC0wOC0wNw==" );
  }


  ngOnInit(): void {
    this.populateBreadcrumb();
    this.initErrors();  
    this.loadsurvey('');
    let params: any = {};
 
    this.action=this.route.snapshot.paramMap.get('action');
    this.id=null;
    if (this.route.snapshot.paramMap.get('id')) {
        this.id=parseInt(this.route.snapshot.paramMap.get('id'));
        params={'id':this.id};
    }
    

    this.apiService.get('surveys-startup-models/listall',params).subscribe(data => {
      for (const g of data.Result) {
        if(g['id']==this.id){
          this.surveymodel=g;
          this.archived=false;
          if((this.surveymodel['archived'])&&(this.surveymodel['archived']==1)){
            this.archived=true;
          }
          if(this.surveymodel['used_in']){
           this.readonly=true;
          }
          if(this.surveymodel['json']){
            this.loadsurvey(this.surveymodel['json']);
            this.isLoading=false;
            return;
   
          }
        }
      }
      this.surveymodel['json'] = '{ "pages" : [' +
      '{ "name":"page1"' +
      ' }]}';
      this.loadsurvey(this.surveymodel['json']);
      this.isLoading=false;

    });

  }
 
  loadsurvey(jsonsurvey){
  
    surveyLocalization.supportedLocales = ["it","en", "de", "es", "fr"];
   
    
    Serializer.addProperty("question", {
      name: "question_weight",
      type: "number",
      displayName: "Question weight",
      category: "general",
      isRequired: true,
      visibleIndex: 0,
      onSetValue: (survey, value) => {
          // ...
          // You can perform required checks or modify the `value` here
          // ...
          // Set the `value`
          survey.setPropertyValue("question_weight", value);
          // You can perform required actions after the `value` is set
          // ...
      }
    });
    Serializer.addProperty("question", {
      name: "main_question",
      type: "boolean",
      displayName: "Main question",
      category: "general",
      isRequired: false,
      readOnly: false, // <-- Sblocca il flag
      visibleIndex: 1,
      onSetValue: (question: any, value: boolean) => {
          if(value){
            // Uso "question.survey" per trovare sempre il questionario giusto in base allo schermo
            if(question && question.survey){
              question.survey.getAllQuestions().forEach(q => {
                  q.main_question = false;
              }); 
            }
          }
          question.setPropertyValue("main_question", value);
      }
    });

    Serializer.addProperty("question", {
      name: "nps_question",
      type: "boolean",
      displayName: "Nps question",
      category: "general",
      isRequired: false,
      readOnly: false, // <-- Sblocca il flag
      visibleIndex: 2,
      onSetValue: (question: any, value: boolean) => {
          if(value){
            // Uso "question.survey" per trovare sempre il questionario giusto in base allo schermo
            if(question && question.survey){
              question.survey.getAllQuestions().forEach(q => {
                  q.nps_question = false;
              }); 
            }
          }
          question.setPropertyValue("nps_question", value);
      }
    });

    /*
    // Flag Engagement Question
    Serializer.addProperty("question", {
      name: "engagement_question",
      type: "boolean",
      displayName: "Engagement question",
      category: "general",
      isRequired: false,
      readOnly: false,
      visibleIndex: 3, // Viene mostrato subito sotto
      onSetValue: (survey: any, value: boolean) => {
        survey.setPropertyValue("engagement_question", value);
      }
    });
    */

    Serializer.addProperty("question", {
      name: "section",
      type: "string",
      displayName: "Section",
      category: "general",
      isRequired: false,
      visibleIndex: 4,
      onSetValue: (survey, value) => {
          // ...
          // You can perform required checks or modify the `value` here
          // ...
          // Set the `value`
          survey.setPropertyValue("section", value);
          // You can perform required actions after the `value` is set
          // ...
      }
    });

    Serializer.addProperty("question", {
      name: "question_chartlabels",
      type: "text",
      displayName: "Chart labels",
      category: "general",
      isRequired: false,
      visibleIndex: 5,
      onSetValue: (survey, value) => {
          // ...
          // You can perform required checks or modify the `value` here
          // ...
          // Set the `value`
          survey.setPropertyValue("question_chartlabels", value);
          // You can perform required actions after the `value` is set
          // ...
      }
    });

    Serializer.addProperty("question", {
      name: "question_relatedquestion",
      type: "dropdown",
      displayName: "Related question",
      category: "general",
      isRequired: false,
      visibleIndex: 6,
      choices:  ((obj) =>{
        if(this.creator){
          let ar=[];
          this.creator.getAllQuestions().forEach(q => {
             ar.push(q.name);
            
          }); 
          return ar;
        } else {
          return [];
        }
      }),
      onSetValue: (survey, value) => {
          // ...
          // You can perform required checks or modify the `value` here
          // ...
          // Set the `value`
          survey.setPropertyValue("question_relatedquestion", value);
          // You can perform required actions after the `value` is set
          // ...
      }
    });
    
    if (!Serializer.findClass("rsalist")) {
    ComponentCollection.Instance.add({
      //Unique component name. It becomes a new question type. Please note, it should be written in lowercase.
      name: "rsalist",
      //The text that shows on toolbox
      title: "Residencies",
      //The actual question that will do the job
      questionJSON: {
          type: "dropdown",
          placeholder: "Select a residency...",
          isRequired: true,
          choices:[ ]

        },
      });
    }
    if (!Serializer.findClass("npssmilyes")) {
      ComponentCollection.Instance.add({
        //Unique component name. It becomes a new question type. Please note, it should be written in lowercase.
        name: "npssmilyes",
        //The text that shows on toolbox
        title: "Smilyes for NPS question",
        //The actual question that will do the job
        questionJSON: {
            type: "imagepicker",
            choices:[
              {value:0,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-01.png'},
              {value:1,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-02.png'},
              {value:2,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-03.png'},
              {value:3,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-04.png'},
              {value:4,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-05.png'},
              {value:5,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-06.png'},
              {value:6,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-07.png'},
              {value:7,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-08.png'},
              {value:8,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-09.png'},
              {value:9,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-10.png'},
              {value:10,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-11.png'}
            ],
            maxImageHeight: 50,
            maxImageWidth: 50,
            minImageHeight: 50,
            minImageWidth: 50,
            showLabel:true
        }
      });
    }


    const creatorOptions = {
      showLogicTab: false,
      showJSONEditorTab:false,
      questionTypes: ["rsalist","npssmilyes","imagepicker","text", "checkbox", "radiogroup", "dropdown","matrix","boolean","rating","comment"]
    };

    this.creator = new SurveyCreatorModel(creatorOptions);

    if(this.readonly){
      this.creator.readOnly=true;
    }
     
    this.creator.onQuestionAdded.add((sender, options)=>{
  
      let questionCounter=1;
      let presente =true;
      while(presente){
        presente =false;
        this.creator.getAllQuestions().forEach(que => {
          if("MANDATORY" +questionCounter==que.name.toUpperCase())     {
            presente=true;
            questionCounter++;
          }   
        }); 
       
        
        
      }
      var q = options.question;
      q.name = "Mandatory" +questionCounter;
     
     
    });
    this.creator.onShowingProperty.add((sender, options) => {
      var propName = options.property.name;
      if(options.property.name=='name'){
        options.canShow = true;
      } else{
        options.canShow = true;
      }
    });

    if(jsonsurvey!=''){
      this.creator.text=jsonsurvey;

    }
   this.surveyCreatorModel =this.creator;

  }
  
  private initErrors() {
    this.errors = {} as any;
  
    
 
  }
 

  private validate() : boolean {
    let isValid : boolean = true;
    
    if (!this.creator.JSON.title) {
      this.addSingle('error', 'Error', 'Title field is required');
       isValid = false;
      
    }
    let arrq=[];
    
    if(this.creator.JSON.pages){

      this.creator.JSON.pages.forEach((p,indp)=>{
        if(p.elements){
          p.elements.forEach((e,inde)=>{
       
            if(arrq.includes(e.name)){
              this.addSingle('error', 'Error', 'Nome domanda duplicato. Impossibile salvare'+e.name);
              isValid = false;
            }
            arrq.push(e.name);

           });
        }
      });
     
    }
    if (!isValid) {
      this.addSingle('error', 'Errore di validazione', 'Impossibile salvare in quanto sono presenti degli errori.');
    }

    return isValid;
  }


  public save() {
  
    this.initErrors();
    if(!this.archived){
      if (!this.validate()) return;
    }
    
    if(this.id){
      this.surveymodel['id']=this.id;
    } 
 
             
    if(!this.creator.JSON.locale){
      this.surveymodel['lang']='en';
    } else {
      this.surveymodel['lang']=this.creator.JSON.locale;
    }
    let j=0;
    let arrq=[];

    if(this.creator.JSON.pages){
      this.creator.JSON.pages.forEach((p,indp)=>{
        if(p.elements){
          p.elements.forEach((e,inde)=>{
            j++;
            if(arrq.includes(e.name))
            arrq.push(e.name);

           });
        }
      });
    }
    this.surveymodel['questions_count']=j;
    this.surveymodel['name']=this.creator.JSON.title;
    this.surveymodel['startup_model']=true;
    this.surveymodel['json']=JSON.stringify( this.creator.JSON );  
    this.surveymodel['archived']=false;
    if(this.archived){
      this.surveymodel['archived']=true;
    }
    this.surveymodel['archived']=false;
    if(this.archived){
      this.surveymodel['archived']=true;
    }
 
    if((this.action=='duplica')&&(this.duplicatename=='')){
      return;
     }
    if(this.action=='duplica'){
      delete this.surveymodel['id'];
      this.surveymodel['name']=this.duplicatename;
     }
    this.apiService.updateStartupSurveyModel(this.surveymodel).subscribe(data => {
      this.addSingle('success', 'Success', 'Survey model saved');
      if(this.action=='duplica'){
         this.router.navigateByUrl('/dashboard/surveys/survey-startup-models');
      }
    });
    
  }
 

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

  private populateBreadcrumb() {
    
  }


  saveduplica(){
    this.action='duplica';
    this.save()
  }
  duplicate(){
    this.showDialogDuplicate=true;
  }

}
